import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router-dom'

/**
 * Opens a modal/form when a query param is present in the URL (e.g. ?new=1).
 * After firing once, removes the param from the URL so navigating away and back
 * doesn't re-trigger it, and so the user can close the modal cleanly.
 */
export function useOpenOnQueryParam(paramName: string, onMatch: () => void) {
  const [params, setParams] = useSearchParams()
  const firedRef = useRef(false)

  useEffect(() => {
    if (firedRef.current) return
    if (!params.has(paramName)) return
    firedRef.current = true
    onMatch()
    const next = new URLSearchParams(params)
    next.delete(paramName)
    setParams(next, { replace: true })
  }, [params, paramName, onMatch, setParams])
}
